// Chat configuration
export const MAX_CHARACTERS = 500;

// Chat constants
export const CHAT_CONSTANTS = {
  PLACEHOLDER_UUID: "PlaceHolderUUID",
  NULL_UUID: "00000000-0000-0000-0000-000000000000",
  ERROR_MESSAGE:
    "We encountered an unexpected error while processing your request. Please try again later. If the problem persists, contact support.",
  DEFINITION_ROOT: "6fd5a109-5ac5-4fe2-bf10-0029f554b977",
  MESSAGES: {
    GO_BACK: "Go Back",
    REPEAT: "Repeat",
    UNABLE_TO_GO_BACK: "Unable to go back to previous message.",
    UNABLE_TO_REPEAT: "Unable to repeat previous message.",
    FEEDBACK_ERROR:
      "We weren't able to get your feedback at this time. Please try again later.",
  },
} as const;

// Moonshine ASR constants
/**
 * Sample rate of the audio. It's the same for both models (Moonshine and Silero VAD)
 */
export const SAMPLE_RATE = 16000;
export const SAMPLE_RATE_MS = SAMPLE_RATE / 1000;

/**
 * Probabilities ABOVE this value are considered as SPEECH
 * Lower value = more sensitive to speech start
 */
export const SPEECH_THRESHOLD = 0.25;

/**
 * If current state is SPEECH, and the probability of the next state
 * is below this value, it is considered as NON-SPEECH.
 * Lowered values are less aggressive in ending speech detection
 */
export const EXIT_THRESHOLD = 0.12;

/**
 * After each speech chunk, wait for at least this amount of silence
 * before considering the next chunk as a new speech chunk
 * Higher values better capture complete phrases but also more latency
 */
export const MIN_SILENCE_DURATION_MS = 400;
export const MIN_SILENCE_DURATION_SAMPLES =
  MIN_SILENCE_DURATION_MS * SAMPLE_RATE_MS;
// At 16kHz sample rate, there are 16,000 samples per second, so 600ms is 9600 samples (600x16)

/**
 * Pad the speech chunk with this amount each side
 * larger values give better end-of-speech capture but also more latency
 */
export const SPEECH_PAD_MS = 400;
export const SPEECH_PAD_SAMPLES = SPEECH_PAD_MS * SAMPLE_RATE_MS;

/**
 * Final speech chunks below this duration are discarded
 */
export const MIN_SPEECH_DURATION_SAMPLES = 250 * SAMPLE_RATE_MS; // 250 ms

/**
 * Maximum duration of audio that can be handled by Moonshine
 */
export const MAX_BUFFER_DURATION = 2;

/**
 * Size of the incoming buffers
 * Smaller values lower latency (256 size = 16ms at 16kHz vs 512 size = 32ms at 16kHz)
 */
export const NEW_BUFFER_SIZE = 256;

/**
 * The number of previous buffers to keep, to ensure the audio is padded correctly
 */
export const MAX_NUM_PREV_BUFFERS = Math.ceil(
  SPEECH_PAD_SAMPLES / NEW_BUFFER_SIZE
);

/**
 * Timer duration for clearing transcription (10 seconds)
 */
export const TRANSCRIPTION_CLEAR_TIMER_MS = 10000;

/**
 * hard coded UUIDs for nodes
 */
export const CONGRATS_MESSAGE_UUID = "66d9bc97-3843-46eb-9103-1195d2efa1bb";
